function IntlPhone() {
  const initializeIntlTelInput = () => {
    const inputs = document.querySelectorAll(".phoneiti");

    inputs &&
      inputs.length &&
      inputs.forEach((intll) => {
        // Ensure input type is 'tel'
        if (intll.type !== "tel") {
          intll.type = "tel";
        }

        // Prevent non-numeric input
        intll &&
          intll.addEventListener("input", function () {
            this.value = this.value.replace(/[^\d]/g, "");
          });

        const iti = window.intlTelInput(intll, {
          hiddenInput: "full_phone",
          initialCountry: "auto",
          initialCountry: "ae", // Adjust as needed
          /* For Country Code */
          separateDialCode: true,
          geoIpLookup(callback) {
            fetch("https://ipinfo.io/json")
              .then((response) => response.json())
              .then((data) => callback(data?.country || "us"))
              .catch(() => callback("us")); // Fallback to "us" in case of error
          },
          utilsScript:
            "https://cdn.jsdelivr.net/npm/intl-tel-input@17.0.19/build/js/utils.js",
        });

        // Update the hidden field on input or country change
        intll &&
          intll.addEventListener("input", () => updateHiddenField(iti, intll));
        intll &&
          intll.addEventListener("countrychange", () =>
            updateHiddenField(iti, intll),
          );
      });

    // Function to update the hidden field with the country code + phone number
    const updateHiddenField = (iti, intll) => {
      const fullPhone = iti.getNumber();
      const hiddenInput = intll
        .closest("form")
        .querySelector('[name="full_phone"]');
      if (hiddenInput) {
        hiddenInput.value = fullPhone;
      }
    };
  };

  // Wait until intlTelInput is available
  const checkInterval = setInterval(() => {
    if (typeof window.intlTelInput === "function") {
      clearInterval(checkInterval);
      initializeIntlTelInput();
    }
  }, 50);
}

export default IntlPhone;
